import { UserAvatar } from "components/Atoms/Avatar";
import SubLabel from "components/Atoms/Sublabel";
import CultureLabel from "components/Culture/CultureLabel";
import { FormSection } from "components/MainSectionTemplate/types";
import React from "react";
import { formatTimeZone, getTimeZoneFromIana } from "shared/utils/dateTimeUtils";
import { getCultureFromLcid } from "utilities/enumutils";

interface Props {
  user: server.dto.UserForAdminOne
}

export const userMainSection = (props: Props): FormSection => {
  const { user } = props;
  const tz = getTimeZoneFromIana(user.ianaTimeZoneId, serverReference.culture.uiLocale);
  return {
    key: "userDetails",
    type: "regular",
    title: "Client",
    fields: [
      {
        key: "name",
        label: "Name",
        render: () => <div>{user.fullName}</div>,
      },
      {
        key: "photo",
        label: "Photo",
        render: () => <UserAvatar user={user} />,
      }, {
        key: "username",
        label: "Username",
        render: () => <div>{user.username}</div>,
      }, {
        key: "language",
        label: "Language",
        render: () => <CultureLabel culture={getCultureFromLcid(user.culture)} />,
      }, {
        key: "timezone",
        label: "Timezone",
        render: () => <div>
          <div>{tz.value}</div>
          <SubLabel>{formatTimeZone(tz)}</SubLabel>
        </div>,
      }, {
        key: "email",
        label: "Email",
        render: () => <div>{user.email}</div>,
      }, {
        key: "lastActivity",
        label: "Last activity",
        render: () => <div>{user.lastActivityText}</div>,
      }
    ]
  }
}